import api from '../../../utils/api';

export const getUsers = () => {
  return api.get('/users');
};

let cancelPutUser;
export const putUser = (userId, data) => {
  if (cancelPutUser) {
    cancelPutUser("Cancel updating user's data");
  }

  return api.put(`/users/${userId}`, data, {
    cancelPutUser: new api.CancelToken((c) => (cancelPutUser = c)),
  });
};
